module.exports = __webpack_public_path__ + "img/rl-main-logo.8bd2f011.svg";